<script>
	import { pageNumber, model } from "../../stores";
	import PageSection from "../../components/PageSection.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";

	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";

	import Select from "../../components/Select.svelte";
	import RadioGroup from "../../components/RadioGroup.svelte";
	import YesNoGroup from "../../components/YesNoGroup.svelte";
	import CheckboxList from "../../components/CheckboxList.svelte";
	import CurrencyInput from "../../components/CurrencyInput.svelte";
	import Input from "../../components/Input.svelte";

	import { yesNoOptions, voyages, bookingMethods, refundOptions } from "../../config";
	import registrationTypes from "../../config/registrationTypes";

	export let pageIndex = null;
	export let nextPage = null;
	export let previousPage = null;
	export let persistUrl = null;
	export let pageTitle = null;
	export let disabled = false;
	export let lastVisitedPage = null;
	export let title = null;

	let required = true;
	const active_nextPage = nextPage;
	const active_persistUrl = persistUrl;

	const ineligible_regStatus = "Active - Ineligible";
	const ineligible_nextPage = "Registration/ThankYou";
	const ineligible_persistUrl = "api/registration";

	// component state updating
	if (!disabled) {
		pageNumber.update((p) => pageIndex);
		$model.LastPageVisited = lastVisitedPage;
		document.title = pageTitle;
	}

	const onChangeRefundProvided = (e) => {
		$model.Cruise.RefundAmount = e.target.value === "Yes, partial refund" ? $model.Cruise.RefundAmount : null;
	};

	const onChangePassengerOnboard = (e) => {
		if (e.target.value === "No") {
			toggleRegflow(true);

			$model.Cruise.Voyages = [];
			$model.Cruise.BookingMethod = null;
			$model.Cruise.OtherBookingMethod = null;
			$model.Cruise.Cost = null;
			$model.Cruise.RefundProvided = null;
			$model.Cruise.RefundAmount = null;

			alert(
				"Important: If you were not a passenger on board one of the affected voyages you are not eligible to register for the class action."
			);
		} else {
			toggleRegflow(false);
		}
	};

	const toggleRegflow = (ineligible = false) => {
		if (ineligible) {
			$model.RegistrationStatus = ineligible_regStatus;
			nextPage = ineligible_nextPage;
			persistUrl = ineligible_persistUrl;
		} else {
			$model.RegistrationStatus = null;
			nextPage = active_nextPage;
			persistUrl = active_persistUrl;
		}
	};

	const onChangeBookingMethod = () => {
		$model.Cruise.OtherBookingMethod = null;
	};

	let questionLabel = "";
	$: questionLabel =
		$model.RegistrationType && $model.RegistrationType === registrationTypes.types.Myself.value ? "you" : "they";

	$: {
		if ($model.Cruise.PassengerOnboard === "No") {
			toggleRegflow(true);
		} else {
			toggleRegflow(false);
		}
	}
</script>

<PageSection>
	<h2>Cruise Details</h2>
	<FormRow>
		<FormColumn>
			<label class:isrequired={required}
				>Were {questionLabel} a passenger on board one of the affected voyages?</label
			>
			<YesNoGroup
				name="passengerOnboard"
				bind:value={$model.Cruise.PassengerOnboard}
				optionList={yesNoOptions}
				{required}
				{disabled}
				on:change={onChangePassengerOnboard}
			></YesNoGroup>
		</FormColumn>
	</FormRow>
	{#if $model.Cruise.PassengerOnboard === "Yes"}
		<FormRow>
			<FormColumn>
				<label for="voyages" class:isrequired={required}>Please select the voyage(s) travelled on:</label>
			</FormColumn>
			<CheckboxList
				validator="checkboxRequired"
				validatorValue="1"
				validatorMessage="At least one item must be selected"
				validatorTarget=".checkbox-error"
				{disabled}
				{required}
				name="voyages"
				options={voyages}
				bind:selectedOptions={$model.Cruise.Voyages}
			></CheckboxList>
		</FormRow>

		<FormRow>
			<FormColumn>
				<label for="bookingMethod" class:isrequired={required}>How was the cruise booked?</label>
			</FormColumn>
			<FormColumn cols="6">
				<Select
					{disabled}
					{required}
					bind:value={$model.Cruise.BookingMethod}
					optionList={bookingMethods}
					id="bookingMethod"
					on:change={onChangeBookingMethod}
				></Select>
			</FormColumn>
		</FormRow>

		{#if $model.Cruise.BookingMethod === "Other"}
			<FormRow>
				<FormColumn cols="6">
					<Input
						id="other_bookingMethod"
						{disabled}
						{required}
						maxlength="40"
						label="If Other, please specify"
						bind:value={$model.Cruise.OtherBookingMethod}
					/>
				</FormColumn>
			</FormRow>
		{/if}

		<FormRow>
			<FormColumn cols="6">
				<CurrencyInput
					{disabled}
					{required}
					label="What was the total cost of the cruise? Please provide your best estimate."
					bind:value={$model.Cruise.Cost}
					id="cost"
				/>
			</FormColumn>
		</FormRow>

		<FormRow>
			<FormColumn>
				<label for="refundProvided" class:isrequired={required}>Has a refund been provided?</label>
			</FormColumn>
			<FormColumn cols="6">
				<RadioGroup
					{disabled}
					{required}
					name="refundProvided"
					bind:value={$model.Cruise.RefundProvided}
					optionList={refundOptions}
					on:change={onChangeRefundProvided}
				/>
			</FormColumn>
		</FormRow>

		{#if $model.Cruise.RefundProvided === "Yes, partial refund"}
			<FormRow>
				<FormColumn cols="6">
					<CurrencyInput
						{disabled}
						{required}
						label="Refund amount"
						bind:value={$model.Cruise.RefundAmount}
						id="refundAmount"
					/>
				</FormColumn>
			</FormRow>
		{/if}
	{/if}

	{#if !disabled}
		<div class="form-group form-row">
			<div class="col-md-12 last">
				<NavigationButtons {persistUrl} {previousPage} {nextPage} pageName={title} tealiumTag={true} />
			</div>
		</div>
	{/if}
</PageSection>
